const panels = document.querySelectorAll('.panel');

panels.forEach(panel => {
  const header = panel.querySelector('.panel-header');
  const content = panel.querySelector('.panel-content');

  header.addEventListener('click', () => {
    panels.forEach(otherPanel => {
      if (otherPanel !== panel) {
        otherPanel.classList.remove('open');
        const toggleIcon = otherPanel.querySelector('.toggle-icon');
        toggleIcon.innerHTML = content.style.display === 'none' ? '<span class="material-symbols-outlined">expand_less</span>' : '<span class="material-symbols-outlined">expand_more</span>';
      }
    });
    setTimeout(() => {
      panel.classList.toggle('open');
      const toggleIcon = panel.querySelector('.toggle-icon');
      toggleIcon.innerHTML = panel.classList.contains('open') ? '<span class="material-symbols-outlined">expand_less</span>' : '<span class="material-symbols-outlined">expand_more</span>';
    }, "100");

  });
});